import AgGridCustomTable from "../../../../../../util/component/AgGridCustomTable";
import {GridApi, GridOptions} from "ag-grid-enterprise";
import {useEffect, useRef, useState} from "react";
import {CellClassParams, ColGroupDef, ICellRendererParams} from "ag-grid-community";
import {AgGridReact} from "ag-grid-react";
import {FormReportModel, IReportRegionMonth} from "../../../../api/types/report";
import {useAgGridLocale} from "../../../../../../config/globalConfig";
import {DEFAULT_PLAN_COL_DEF} from "../../../../constants";
import {useFormContext, UseFormReturn} from "react-hook-form";
import {useTranslation} from "react-i18next";
import { formatNumbers } from "../../../../../../util/state/commonFunctions";

const RegionMonthReport = ({
                               withCurrency,
                               result,
                               divided
                           }: {
    withCurrency: boolean;
    result: any;
    divided: boolean;
}) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // REPORT 6
    const [valuesRegionMonth, setValuesRegionMonth] = useState<IReportRegionMonth>({
        rows: [
            {
                name: "",
                tot: 0,
                values: []
            }
        ],
        columns: [
            {
                name: "",
                values: []
            }
        ]
    });

    const gridRefRegionMonth = useRef<AgGridReact>(null);

    const [gridApiReportRegionMonth, setGridApiReportRegionMonth] = useState<GridApi | null>(null);

    // Use AgGrid Locale
    const agGridLocale = useAgGridLocale();

    const form = useFormContext<FormReportModel>();

    const defaultColDef = {...DEFAULT_PLAN_COL_DEF};

    const buildColDefRegionMonth = (form: UseFormReturn<FormReportModel, any>): ColGroupDef[] => {
        return [
            {
                headerName: "",
                children: [
                    {
                        headerName: `${t("pricing:report.labels.groupsOfLocations")}`,
                        pinned: "left",
                        width: 200,
                        cellRenderer: (params: ICellRendererParams) => {
                            return valuesRegionMonth.rows.length ===
                            params.rowIndex + 1
                                ? "TOTALI"
                                : params.data.name;
                        },
                        cellStyle: (params: CellClassParams) => ({
                            fontWeight:
                                valuesRegionMonth.rows.length ===
                                params.rowIndex + 1
                                    ? "bold"
                                    : "normal"
                        })
                    }
                ]
            },
            ...valuesRegionMonth.columns?.map((yearObj, yearIndex) => ({
                headerName: yearObj.name,
                children: yearObj.values?.map((month, monthIndex) => ({
                    headerName: month,
                    minWidth: 150,
                    flex: 1,
                    cellRenderer: (params: ICellRendererParams) => {
                        const oldYears = valuesRegionMonth.columns.slice(0, yearIndex);
                        const oldColumnsSum = oldYears.reduce((acc: number, oldYear: { values: string[]; name: string }) => {
                            acc = acc + oldYear.values.length;
                            return acc;
                        }, 0);

                        return `${withCurrency ? "€ " : ""} ${
                            divided ? formatNumbers(params.data?.values[oldColumnsSum + monthIndex] / 100) : formatNumbers(params.data?.values[oldColumnsSum + monthIndex])}`;
                    },
                    cellStyle: (params: CellClassParams) => ({
                        fontWeight:
                            valuesRegionMonth.rows.length ===
                            params.rowIndex + 1 ||
                            params.data?.location === null
                                ? "bold"
                                : "normal"
                    })
                }))
            })),
            {
                headerName: "",
                children: [{
                    headerName: "TOT",
                    pinned: "right",
                    width: 200,
                    cellRenderer: (params: ICellRendererParams) =>
                        `${withCurrency ? "€ " : ""} ${
                            divided ? formatNumbers(params.data.tot / 100) : formatNumbers(params.data.tot)
                        }`,
                    cellStyle: {
                        fontWeight: "bold"
                    }
                }]
            }
        ];
    };

    const gridOptionsRegionMonth: GridOptions = {
        rowData: valuesRegionMonth.rows,
        columnDefs: buildColDefRegionMonth(form),
        defaultColDef: defaultColDef,
        rowSelection: "multiple",
        localeText: agGridLocale,
        suppressRowClickSelection: true,
        domLayout: "autoHeight",
        enableRangeSelection: true,
        enableCellTextSelection: false
    };

    const onGridReadyRegionMonth = (params: any) => {
        setGridApiReportRegionMonth(params.api);
    };

    useEffect(() => {
        setValuesRegionMonth(result);
    }, [result]);

    return (
        <AgGridCustomTable
            gridRef={gridRefRegionMonth}
            gridOptions={gridOptionsRegionMonth}
            onGridReady={onGridReadyRegionMonth}
            pagination={false}
        />
    );
};

export default RegionMonthReport;
